// src/api.js
import axios from 'axios';

const apiClient = axios.create({
    baseURL: 'https://24924909.com',
    timeout: 10000,
    headers: {'Content-Type': 'application/json'}
});

// 添加请求拦截器
apiClient.interceptors.request.use(config => {
    // 在发送请求之前做些什么，例如设置token等
    // const token = localStorage.getItem('token');
    // if (token) {
    //     config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
apiClient.interceptors.response.use(response => {
    // 对响应数据做点什么
    return response.data;
}, error => {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default {
    get(url, params) {
        return apiClient.get(url, { params });
    },
    post(url, data) {
        return apiClient.post(url, data);
    },
    put(url, data) {
        return apiClient.put(url, data);
    },
    delete(url) {
        return apiClient.delete(url);
    }
};